import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex: none;
  margin-top: 1rem;
`
const Button = styled.button`
  flex: 0;
  min-width: 6rem;
`
const QuestionContainer = styled.div`
  flex: none;
`


export default function ConfirmDialog({ question, onNoClick, onYesClick}) {
  return (
    <Container>
      <QuestionContainer>
        {question}
      </QuestionContainer>
      <ButtonContainer>
        <Button onClick={onYesClick} >
          yes
        </Button>
        <Button onClick={onNoClick} >
          no
        </Button>
      </ButtonContainer>
    </Container>
  );
}
